module.exports = __webpack_public_path__ + "img/risk-volumes-pie.12308899.png";